module.exports = __webpack_public_path__ + "img/image12.abb877b3.jpeg";